import React from 'react';
import PropTypes from 'prop-types';
import { QuloiBlueLogo } from '../icons/icons';
import './action-status.scss';

function ActionStatus({ children, title, description }) {
  return (
    <div className="action-status-container">
      <div className="action-status-header">
        <div className="action-status-logo">
          <QuloiBlueLogo />
        </div>
      </div>
      <div className="action-status-body">
        <div className="action-status-image">{children}</div>
        <h1 className="action-status-title">{title}</h1>
        <p className="action-status-description">{description}</p>
      </div>
    </div>
  );
}

export default ActionStatus;
ActionStatus.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
};
ActionStatus.defaultProps = {
  children: null,
  title: '',
  description: '',
};
